import { ThemeProp } from "../../../styles/theme";
import styled from "@emotion/styled";

export const TokensSecondRow = styled.div<ThemeProp>(({ theme }) => ({
  color: theme.font.secondary.default,
  fontWeight: theme.fontWeights["work-sans-2"],
  fontSize: theme.fontSize["4"],
  whiteSpace: "nowrap",
}));
